export default __webpack_public_path__ + "app/images/common/bg-linshare-desktop.png";